@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.pay-wrapper {
  width: 100%;
}

:global(.header-txt).pay-header {
  text-align: center;
  margin: 1em 0;
  line-height: 40px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.pay-body {
  color: colors.$body-text;

  a:hover {
    text-decoration: underline;
  }

  span {
    color: colors.$body-text;
  }
}

.pay-continue-button {
  margin: 40px 60px 20px 60px;
  font-size: 1.125em;
  padding: 14px 16px;
}

// Flexpay

:global(.flexpay) {
  .pay-body {
    color: colors.$flexpay-body-text;

    span {
      color: colors.$flexpay-body-text;
    }
  }

  .pay-header {
    text-align: left;
    margin-top: 36px;
  }
}
